<header>
  <h1>Retired User Admin</h1>
  <search-text (search)="setSearch($event)"></search-text>
</header>
<section class="retired-users">
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!Users?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No retired partners found.
        </mat-card-content>
      </mat-card>
    }
    @if (!!Users.length) {
      <table mat-table [dataSource]="DataSource" class="retired-user">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef>First Name</th>
          <td mat-cell *matCellDef="let row">{{row.first_name}}</td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef>Surname</th>
          <td mat-cell *matCellDef="let row">{{row.last_name}}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row">{{row.email}}</td>
        </ng-container>
        <ng-container matColumnDef="employeeNumber">
          <th mat-header-cell *matHeaderCellDef>Employee No.</th>
          <td mat-cell *matCellDef="let row">{{row.employee_number }}</td>
        </ng-container>
        <ng-container matColumnDef="branchNumber">
          <th mat-header-cell *matHeaderCellDef>Branch No.</th>
          <td mat-cell *matCellDef="let row">{{row.branch_number }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="actions">
            <button
              [routerLink]="['/user', row.id]"
              [queryParams]="{role: userRole()}"
              mat-icon-button
              matTooltip="Edit partner details"
              >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              (click)="resetUserPassword(row)"
              mat-icon-button
              matTooltip="Reset partner password."
              >
              <mat-icon>lock</mat-icon>
            </button>
            <button
              (click)="generateUserPassword(row)"
              mat-icon-button
              matTooltip="Generate partner password."
              >
              <mat-icon>autorenew</mat-icon>
            </button>
          </td>
        </ng-container>
      </table>
      @if (PageEvent) {
        <mat-paginator
          (page)="DataSource.loadWithPageEvent($event)"
          [length]="PageEvent.length"
          [pageIndex]="PageEvent.pageIndex"
          [pageSize]="PageEvent.pageSize"
        ></mat-paginator>
      }
    }
  }
</section>
